import { Box, Typography } from "@material-ui/core";

import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
} from "@mui/material";

import PaginationBase from "components/molecules/PaginationBase";
import { LoaderIcon } from "react-hot-toast";

import dayjs from "dayjs";
import { useStyles } from "./styles";

import "./styles.css";

require("dayjs/locale/en");
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

// Sample table header data with `params`
// const tableHeadersData = [
//   {
//     content: "Name",
//     sx: { textAlign: "center" },
//     params: {}, // Even if empty, `params` must be here
//   },

// ];

// Define DataItem with content, sx, and params
type HeaderDataItem = {
  content?: any; // content can be of any type
  sx?: any; // sx is a style object
  params?: any; // params is an object that can hold any key-value pairs
};

// Sample table body data with `params`
// const tableBodyData = [
//   [
//     {
//       content: "John Doe",
//       sx: { minWidth: "200px" },
//       params: {}, // Empty params
//     },
//   ]]

// Define DataItem with content, sx, and params
type BodyDataItem = {
  content?: any; // content can be of any type
  sx?: any; // sx is a style object
  params?: any; // params is an object that can hold any key-value pairs
};

// Define DataItem with content, sx, and params
type BodyDataListItem = BodyDataItem[];

interface CustomTableProps {
  headersDataList?: HeaderDataItem[]; // Array of header data (optional)
  bodyDataList?: BodyDataListItem[]; // Array of body data (optional)
  totalPages?: number; // Total number of pages (optional)
  loading?: boolean; // Flag for loading state (optional)
  page?: number; // Current page (optional)
  rowsPerPage?: number; // Number of rows per page (optional)
  setPage?: (page: number) => void; // Function to set the current page (optional)
  setRowsPerPage?: (rowsPerPage: number) => void; // Function to set the number of rows per page (optional)
  NoDataFoundText?: string; // Text to display when no data is found (optional)
  tableSX?: React.CSSProperties; // Inline styles for the table (optional)
  showPagenation?: boolean;
  onClickOnRow?: () => void;
}

export default function CustomTable({
  headersDataList = [],
  bodyDataList = [],
  totalPages = 0,
  loading = false,
  page = 0,
  showPagenation = true,
  rowsPerPage = 0,
  setPage = () => {},
  setRowsPerPage = () => {},
  NoDataFoundText = "No Data Found",
  tableSX = {
    height: "calc(100vh - 320px)",
  },
  onClickOnRow = () => {},
}: CustomTableProps) {
  const classes = useStyles();

  return (
    <Box
      style={{
        borderRadius: 10,
        padding: 0,
        paddingLeft: 0,
        paddingRight: 0,
        position: "relative",
      }}
    >
      <TableContainer
        sx={{
          padding: "1% 0%",
          paddingTop: 0,
          paddingBottom: 0,
          ...tableSX,
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {headersDataList?.map((each: any, index: any) => (
                <TableCell
                  key={index}
                  className={classes.tableHeadCell}
                  sx={{ textAlign: "center", ...each?.sx ,
                    // fontSize: "12px !important",
                  }}
                >
                  {each?.content}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {bodyDataList.length > 0 ? (
              bodyDataList.map((eachRow: any, index: any) => (
                <TableRow
                  onClick={eachRow[0]?.params?.onClickOnRow}
                  key={index}
                  hover
                  role="checkbox"
                  tabIndex={-1}
                >
                  {eachRow.map((each: any, index: any) => (
                    <TableCell
                      key={index}
                      className={classes.tableBodyCell}
                      sx={{ textAlign: "center", ...each?.sx }}
                      {...each?.params}
                    >
                      {each?.content}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow
                style={{
                  height: "80px",
                  width: "100%",
                  position: "relative",
                }}
                key="empty data"
              >
                <Typography
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontWeight: 700,
                  }}
                  variant="body1"
                >
                  {loading ? (
                    <LoaderIcon
                      style={{
                        height: "35px",
                        width: "35px",
                      }}
                    />
                  ) : (
                    NoDataFoundText
                  )}
                </Typography>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {showPagenation && (
        <div
          style={{
            position: "sticky",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "#FFF",
            paddingRight:"60px"
          }}
        >
          <PaginationBase
            perPage={rowsPerPage}
            totalPage={totalPages}
            pageIndex={page}
            changePage={setPage}
            changePerPage={setRowsPerPage}
          />
        </div>
      )}
    </Box>
  );
}
